import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mono-common-header-search',
  templateUrl: './header-search.component.html'
})
export class HeaderSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
